const state = () => ({
  userInfo: {
    name: 'test',
    img: 'url',
    id: 0
  },
  defaultLogin: '0',
  loginShow: false,
  rechargeShow: false
})

const getters = {
  getUserInfo(state, getters, rootState) {
    return {
      userInfo: state.userInfo
    }
  },
}
const mutations = {
  setInfo (state, payload) {
    console.log(payload)
    state.userInfo = {
      ...state.userInfo,
      ...payload
    }
  },
  showLoginState (state, payload) {

    state.loginShow = payload.show
    state.defaultLogin = payload.value || '0'
  },
  changeRechargeState(state, showState) {
    state.rechargeShow = showState
  }
}
const actions = {
  setInfo({ commit, state }, payload) {
    commit('setInfo', payload)
  }
}


export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}